// extracted by mini-css-extract-plugin
export var alertIcon = "_mz-0";